export const examSchedule = [
    {

        subject: "English",
        examDate: "13 Mar 2025",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "101",
        maxMarks: "100",
        minMarks: "35",
        key:1
    },
    {

        subject: "Bahasa Melayu",
        examDate: "14 Mar 2025",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "104",
        maxMarks: "100",
        minMarks: "35",
        key:2
    },
    {

        subject: "Physics",
        examDate: "15 Mar 2025",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "103",
        maxMarks: "100",
        minMarks: "35",
        key:3
    },
    {

        subject: "Chemistry",
        examDate: "16 Mar 2025",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "105",
        maxMarks: "100",
        minMarks: "35",
        key:4
    },
    {

        subject: "Maths",
        examDate: "17 Mar 2025",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "106",
        maxMarks: "100",
        minMarks: "35",
        key:5
    },
    {

        subject: "Computer",
        examDate: "18 Mar 2025",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "102",
        maxMarks: "100",
        minMarks: "35",
        key:6
    },
    {

        subject: "Env Science",
        examDate: "19 Mar 2025",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "107",
        maxMarks: "100",
        minMarks: "35",
        key:7
    }
]
